import { createTheme } from '@mui/material/styles';

/**
 * Web theme aligned with mobile brand tokens (`mobile/src/utils/theme.ts`).
 * Use `brandColors` for one-off sx values; prefer theme.palette in components.
 */
export const brandColors = {
  primary: '#002B5B',
  secondary: '#C9A84C',
  background: '#F8F8F6',
  surface: '#FFFFFF',
  text: '#0D1117',
  textSecondary: '#6B7280',
  border: '#E4E7EC',
  success: '#16A34A',
  error: '#DC2626',
  warning: '#D97706',
  info: '#2563EB',
} as const;

const dwelloTheme = createTheme({
  palette: {
    primary: {
      main: brandColors.primary,
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: brandColors.secondary,
      contrastText: brandColors.text,
    },
    text: {
      primary: brandColors.text,
      secondary: brandColors.textSecondary,
    },
    background: {
      default: brandColors.background,
      paper: brandColors.surface,
    },
    success: { main: brandColors.success },
    error: { main: brandColors.error },
    warning: { main: brandColors.warning },
    info: { main: brandColors.info },
  },
  shape: {
    borderRadius: 8,
  },
  typography: {
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    h1: { color: brandColors.text, fontWeight: 700 },
    h2: { color: brandColors.text, fontWeight: 700 },
    h3: { color: brandColors.text, fontWeight: 700 },
    h4: { color: brandColors.text, fontWeight: 700 },
    h5: { color: brandColors.text, fontWeight: 700 },
    h6: { color: brandColors.text, fontWeight: 700 },
    body1: { color: brandColors.text },
    body2: { color: brandColors.textSecondary },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 8,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: brandColors.surface,
          borderRadius: 12,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: brandColors.surface,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: brandColors.primary,
        },
      },
    },
  },
});

export default dwelloTheme;
